module.exports = __webpack_public_path__ + "static/oxfordvalentinedaysign-2004b8202c40779b6759788cfe594bdf.jpg";